// vueform.config.js

import en from '@vueform/vueform/locales/en'
import bootstrap from '@vueform/vueform/themes/bootstrap'

export default {
  theme: bootstrap,
  locales: { en },
  locale: 'en',
}